import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { ProductBannerCardWithOverlay } from '@sg/garnish';

import { useCustomProductContent } from './hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridCustomProductCard = (props: MenuContentProductCardProps) => {
  const { product, generateHref } = props;

  const router = useRouter();

  // ─── Remote Data ─────────────────────────────────────────────────────

  const { content } = useCustomProductContent({
    customProductType: product.customType,
  });

  // ─── Helpers ─────────────────────────────────────────────────────────

  const navigate = useCallback(() => {
    router.navigate(generateHref(product.slug));
  }, [generateHref, product.slug, router]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ProductBannerCardWithOverlay
      title={content.heading}
      description={content.body}
      onCtaPress={navigate}
      ctaLabel={content.buttonLabel}
      ctaPalette={content.buttonPalette}
      isDisabled={product.outOfStock}
      backgroundImage={content.backgroundImage}
      backgroundOverlayColor={content.backgroundOverlayColor}
      textColor={content.textColor}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuContentProductCardProps = {
  product: {
    slug: string;
    outOfStock: boolean;
    customType?: string | null;
  };
  generateHref: (productSlug: string) => string;
};
